// Invoices are issued by the Greek branch, so a Greek billing address owes
// Greek VAT on top of the plan price and everyone else does not - the rule
// the backend applies in `payment/vat.py` (`GREEK_COUNTRY_VALUES`). The
// billing form stores the spelled-out name; the ISO code covers an address
// entered any other way.
const GREEK_COUNTRY_VALUES = ['GR', 'GREECE']

export const isGreekBillingCountry = (country?: string | null) =>
  GREEK_COUNTRY_VALUES.includes((country ?? '').trim().toUpperCase())
